export default {
  inject: ['load'],
  data() {
    return {
      allHeadacheIllnessHistoriesForOther: [],
      headacheIllnessHistory: null,
    };
  },
  methods: {
    getListOfHeadacheIllnessHistoriesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllHeadacheIllnessHistories').then(() => {
        if (this.$store.state.headacheIllnessHistoryModule.successFlag) {
          this.allHeadacheIllnessHistoriesForOther =
            this.$store.state.headacheIllnessHistoryModule.allHeadacheIllnessHistories;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.headacheIllnessHistoryModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfHeadacheIllnessHistoriesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getHeadacheIllnessHistoryFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getHeadacheIllnessHistory', id).then(() => {
        if (this.$store.state.headacheIllnessHistoryModule.successFlag) {
          this.headacheIllnessHistory =
            this.$store.state.headacheIllnessHistoryModule.headacheIllnessHistory;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.headacheIllnessHistoryModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getHeadacheIllnessHistoryFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.headacheIllnessHistoryModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
